import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
  MatProgressBarModule,
  ProgressBarMode,
} from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { DialogComponent } from '../../../shared/components/dialogbox/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { FileDownloadService } from '../../../core/services/DownloadService/file-download.service';
import { CartService } from '../../../core/services/cart/cart.service';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../../core/services/checkout/order.service';
import { FileSizePipe } from '../../../core/pipes/file-size.pipe';
import { FileSettings } from '../../../app-constant';
import { GenerateOrderExcel } from '../../../core/models/checkout/generate-order-excel';
import { ConfirmDialogBoxComponent } from '../../../shared/components/dialogbox/confirm-dialog-box/confirm-dialog-box.component';

@Component({
  selector: 'app-excel-upload',
  standalone: true,
  imports: [
    MatTabsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    CommonModule,
    MatTooltipModule,
    FileSizePipe,
  ],
  providers: [FileSizePipe],
  templateUrl: './excel-upload.component.html',
  styleUrl: './excel-upload.component.scss',
})
export class ExcelUploadComponent {
  form: FormGroup;
  maxNumberOfTabs: number = 1;
  selectedIndex: number = 0;
  constructor(
    private cartService: CartService,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      poNumber: [''], // Initialize the poNumber control
      invoiceEmail: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(60)],
      ],
    });
  }
  private fileDownloadService = inject(FileDownloadService);
  private orderService = inject(OrderService);
  private dialog = inject(MatDialog);
  private products: any = [];
  private grandTotal!: number;
  router = inject(Router);
  mode: ProgressBarMode = 'determinate';
  value = 0;
  uploadProductFile: string = '';
  isFileuploaded: boolean = false;
  productFileSize: number = 0;
  bufferValue = 1000;
  selectedFiles: File;
  private clientId: number = 0;
  private clientName: string = '';
  private selectedCountryIsoCode: any;
  private route = inject(ActivatedRoute);
  private localStorage = inject(AesEncDecService);
  fileSettings: any = FileSettings;
  downloadSuccessError: boolean = false;
  private generateOrderExcelRequest = new GenerateOrderExcel();

  generateExcel() {
    const loginDetails = JSON.parse(
      (this.localStorage.getData('loginDetails') as any) || '{}',
    );
    this.cartService.getProducts().subscribe((res) => {
      this.products = res;
      console.log(this.products.length);
      // this.grandTotal = this.cartService.getTotalPrice();
    });
    this.clientName = loginDetails[0].companyName;
    this.clientId = loginDetails[0].cPortalClientDetailsId;
    this.selectedCountryIsoCode =
      (localStorage.getItem('country') as any) || '';

    this.generateOrderExcelRequest.clientName = loginDetails[0].companyName;
    this.generateOrderExcelRequest.countryISO =
      (localStorage.getItem('country') as any) || '';
    this.generateOrderExcelRequest.clientId =
      loginDetails[0].cPortalClientDetailsId;
    this.generateOrderExcelRequest.ordersList = this.products.map(
      (product: any) => ({
        itemSKU: product.item_SKU,
        itemname: product.item_Name,
      }),
    );
    this.orderService.generateExcel(this.generateOrderExcelRequest).subscribe({
      next: (response: any) => {
        if (response.responseCode === '1000') {
          this.fileDownloadService.downloadFileFromBlobUrl(
            response.blobUri,
            'OrderExcel.xlsx',
          );
          this.nextStep();
        } else {
          this.dialog.open(DialogComponent, {
            minWidth: '300px',
            data: {
              message: response.responseMessage,
            },
          });
        }
      },
      error: (err) => {
        if (err.error.ResponseMessage) {
          this.dialog.open(DialogComponent, {
            minWidth: '300px',
            data: {
              message: err.error.ResponseMessage,
            },
          });
        }
      },
    });
  }
  downloadTemplate(): void {
    const blobUrl = environment.blobExcelDomain;
    const filename = blobUrl.substring(blobUrl.lastIndexOf('/') + 1);
    this.fileDownloadService.downloadFileFromBlobUrl(blobUrl, filename);
  }
  nextStep() {
    if (this.selectedIndex < 0) this.selectedIndex = 0;
    if (this.selectedIndex != this.maxNumberOfTabs)
      this.selectedIndex = this.selectedIndex + 1;
  }
  previousStep() {
    //  if (this.selectedIndex > 0)
    this.selectedIndex = this.selectedIndex - 1;
  }
  deleteUploadedExcel() {
    this.isFileuploaded = false;
    this.uploadProductFile = '';
    this.downloadSuccessError = false;
    this.selectedFiles = new File([''], '');
    this.value = 0;
  }

  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    if (files.length > 1) {
      this.dialog.open(DialogComponent, {
        minWidth: '300px',
        data: {
          message: 'Only one file is allowed',
        },
      });
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (
        fileExtension &&
        this.fileSettings.allowedExcelExtensions.includes(fileExtension)
      ) {
        this.uploadProductFile = file.name;
        this.value = 100;
        this.isFileuploaded = true;
        this.selectedFiles = file;

        this.productFileSize = file.size;
      } else {
        this.dialog.open(DialogComponent, {
          minWidth: '300px',
          data: {
            message: 'Invalid file type. Please upload an Excel file.',
          },
        });
      }
    }
  }
  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
  }
  downloadOrderReviewFile() {
    const response = JSON.parse(
      this.localStorage.getData('downloadOrderExcelReport'),
    );
    const filename = response.fileName;
    const blobUrl = environment.OrderExcelDomain + filename;
    this.fileDownloadService.downloadFileFromBlobUrl(blobUrl, filename);
  }
  reviewOrder() {
    const poNumber = this.form.get('poNumber')?.value;
     const invoiceEmail = this.form.get('invoiceEmail')?.value;
    const loginDetails = JSON.parse(
      (this.localStorage.getData('loginDetails') as any) || '{}',
    );
    this.clientId = loginDetails[0].cPortalClientDetailsId;
    this.selectedCountryIsoCode =
      (localStorage.getItem('country') as any) || '';
    this.orderService
      .uploadFiles(
        this.selectedFiles,
        this.clientId,
        this.selectedCountryIsoCode,
        'OrderValidate',
        poNumber,
        invoiceEmail
      )
      .subscribe({
        next: (response: any) => {
          this.downloadSuccessError = true;
          this.localStorage.saveData(
            'downloadOrderExcelReport',
            JSON.stringify(response),
          );
        },
        error: (err) => {
          if (err.error.ResponseMessage) {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: err.error.ResponseMessage,
              },
            });
          }
        },
      });
  }
  cancelOrder() {
    this.localStorage.removeData('orderbenificiary');
    this.cartService.removeAllCart();
    this.localStorage.removeData('country');
    this.router.navigateByUrl('catalogue-view');
  }
  openConfirmationBox() {
    debugger;
    const dialogRef = this.dialog.open(ConfirmDialogBoxComponent, {
      minWidth: '300px',
      data: {
        message:
          'Please make sure you have review order carefully. Are you sure do you want to proceed for place order?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.SubmitExcelUpload();
      } else {
        this.previousStep();
      }
    });
  }
  SubmitExcelUpload() {
    const poNumber = this.form.get('poNumber')?.value;
    const invoiceEmail = this.form.get('invoiceEmail')?.value;
    const loginDetails = JSON.parse(
      (this.localStorage.getData('loginDetails') as any) || '{}',
    );
    this.clientId = loginDetails[0].cPortalClientDetailsId;
    this.selectedCountryIsoCode =
      (localStorage.getItem('country') as any) || '';
    this.orderService
      .uploadFiles(
        this.selectedFiles,
        this.clientId,
        this.selectedCountryIsoCode,
        'OrderSubmit',
        poNumber,
        invoiceEmail
      )
      .subscribe({
        next: (response: any) => {
          this.localStorage.removeData('downloadOrderExcelReport');
          this.localStorage.saveData(
            'downloadOrderExcelReport',
            JSON.stringify(response),
          );
          this.localStorage.removeData('orderbenificiary');
          this.cartService.removeAllCart();
          this.localStorage.removeData('country');
          this.downloadSuccessError = false;
          this.uploadProductFile = '';
          this.router.navigate(['order-placed'], {
            queryParams: { id: response.orderNumber, source: 'excel' },
          });
        },
        error: (err) => {
          if (err.error.ResponseMessage) {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: err.error.ResponseMessage,
              },
            });
          }
        },
      });
  }

  getInvoiceEmailErrorMessage(): string {
    const control = this.form.get('invoiceEmail');
    if (control?.hasError('required')) {
      return 'Email is required';
    }
    if (control?.hasError('email')) {
      return 'Please enter a valid email address';
    }
    if (control?.hasError('maxlength')) {
      return 'Maximum length is 60 characters';
    }
    return '';
  }
}
